// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../node_modules/postcss-loader/src/index.js!../../styleGuide.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".src-components-Sources-Sources__sources--36YqM{font-family:Quicksand,sans-serif;font-weight:700;font-size:11rem;margin-top:2rem}.src-components-Sources-Sources__link--1-FLg{color:" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["gameBackgroundColor"] + ";text-decoration:underline}", ""]);
// Exports
exports.locals = {
	"gameBackgroundColor": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["gameBackgroundColor"] + "",
	"sources": "src-components-Sources-Sources__sources--36YqM",
	"link": "src-components-Sources-Sources__link--1-FLg"
};
module.exports = exports;
